var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.total > _vm.pageSize)?_c('div',{staticClass:"pagination"},[_c('el-pagination',_vm._g(_vm._b({attrs:{"pageSize":_vm.pageSize,"total":_vm.total,"layout":"prev, pager, next"}},'el-pagination',_vm.$attrs,false),_vm.$listeners))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }